require('./lbaPointsOfInterest.scss');
const $inject = [];
const lbaPointsOfInterest = function () {
  return {
    restrict: 'A',
    scope: {
      settings: '<',
    },
    bindToController: true,
    controller: 'lbaPointsOfInterestCtrl',
    controllerAs: 'vm',
    template: require('./lbaPointsOfInterest.html')
  }
};

lbaPointsOfInterest.$inject = $inject;

export default lbaPointsOfInterest;


// WEBPACK FOOTER //
// ./src/components/lbaPointsOfInterest/lbaPointsOfInterestDir.js